import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
  import { useTranslationLanguagesStore } from '@/stores/checklist/translationLanguages';
  import { LanguageTranslationStatus } from '@/entities/checklist';
  import { t } from '@/ui/i18n/i18n';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { AI_TRANSLATION_CONFIRM_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import { reload } from '@/ui/helpers';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  emits: ['language-selected'],
  setup(__props, { emit }) {

  const translationLanguagesStore = useTranslationLanguagesStore();
  const key = ref(0);
  const selectedLang = ref(translationLanguagesStore.selectedLanguageId);
  const pendingLanguageId = ref<number | null>(null);

  

  const [isConfirmModalOpen, openConfirmModal, closeConfirmModal] = useModal();

  const selectedLabel = computed(() => selectedLang.value === 0
    ? t('template-builder.translations.original')
    : options.value.find(option => option.id === selectedLang.value)?.label);

  const options = computed(() => {
    return [
      {
        id: 0,
        locale: 'original',
        aiEnabled: false,
        status: LanguageTranslationStatus.completed,
      },
      ...translationLanguagesStore.translationLanguages,
    ].map(lang => ({
      ...lang,
      label: lang.id === 0 ? t('template-builder.translations.original-language') : t(`language.${lang.locale}`),
      disabled: isLangDisabled(lang.aiEnabled, lang.status),
    }));
  });

  const isLangDisabled = (aiEnabled: boolean, status: LanguageTranslationStatus) => {
    if (!aiEnabled) {
      return status === LanguageTranslationStatus.inProgress;
    }

    return [LanguageTranslationStatus.pending, LanguageTranslationStatus.inProgress].includes(status);
  };

  const isCurrentLanguageAiEnabled = (): boolean => {
    if (selectedLang.value === 0) {
      return false;
    }

    return translationLanguagesStore
      .translationLanguages
      .find(lang => lang.id === selectedLang.value)
      ?.aiEnabled ?? false;
  };

  const onLanguageChange = (id: number) => {
    if (isCurrentLanguageAiEnabled()) {
      reloadBuilder(id);

      return;
    }

    pendingLanguageId.value = id;
    openConfirmModal();
  };

  const confirmLanguageSwitch = () => {
    if (pendingLanguageId.value === null) {
      return;
    }

    emit('language-selected', pendingLanguageId.value);
    closeConfirmModal();
  };

  const declineLanguageSwitch = () => {
    key.value++;
    pendingLanguageId.value = null;
    closeConfirmModal();
  };

  const reloadBuilder = (id: number) => {
    const param = id > 0 ? { key: 'language', value: String(id) } : null;
    reload(param);
  };

return { __sfc: true,translationLanguagesStore, key, selectedLang, pendingLanguageId, emit, isConfirmModalOpen, openConfirmModal, closeConfirmModal, selectedLabel, options, isLangDisabled, isCurrentLanguageAiEnabled, onLanguageChange, confirmLanguageSwitch, declineLanguageSwitch, reloadBuilder, ConfirmationModal, AI_TRANSLATION_CONFIRM_MODAL_WIDTH }
}

})